import { createErrorSelector, createLoadingSelector } from "../../utils/reduxUtils";
import { RESERVATIONS_INDICATORS } from "../actions";

export const reservationsIndicatorsSelector = () => (state: any) => state.reservationsIndicators;

export const reservationsIndicatorsLoadingSelector = createLoadingSelector([RESERVATIONS_INDICATORS]);
export const reservationsIndicatorsErrorSelector = createErrorSelector([RESERVATIONS_INDICATORS]);
